import { v4 as uuidv4 } from 'uuid';
import { ChildAccountDisplayObject } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/types';

export function makeDisplayObjects(
  names: string[]
): ChildAccountDisplayObject[] {
  // Same name might display multiple times in the UI
  // Giving each name a unique key lets us treat each name separately
  const childAccountDisplayObjects = names.map((name) => ({
    name,
    uniqueDisplayKey: uuidv4(),
    isDisabled: false,
    isBeingEdited: false,
  }));

  return childAccountDisplayObjects;
}
